import { Example } from "~/components/shared/Examples/useExamples";

export function exampleUrl(example: Example): string {
  const params = new URLSearchParams(window.location.search);

  params.set("template", example.repository_url);

  return `${window.location.pathname}?${params.toString()}`;
}
